import { render, staticRenderFns } from "./orderEntering.vue?vue&type=template&id=835e4bce&scoped=true"
import script from "./orderEntering.vue?vue&type=script&lang=js"
export * from "./orderEntering.vue?vue&type=script&lang=js"
import style0 from "./orderEntering.vue?vue&type=style&index=0&id=835e4bce&prod&lang=less"
import style1 from "./orderEntering.vue?vue&type=style&index=1&id=835e4bce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835e4bce",
  null
  
)

export default component.exports